import { SessionStatus } from '@/libs/graphql';
import { STATUS } from '@/routes/dashboard/types';

export const getSessionStatusText = (
  status: SessionStatus,
  availableUntil: Date | null,
  expiredAt: Date,
) => {
  const now = new Date();

  // Handle EXPIRED status - never started, show as OVERDUE
  if (status === SessionStatus.Expired) {
    return STATUS.OVERDUE;
  }

  // Handle EXPIRED_IN_SESSION status - started but didn't finish
  if (status === SessionStatus.ExpiredInSession) {
    return STATUS.INCOMPLETE;
  }

  if (
    (status === SessionStatus.NotStarted || status === SessionStatus.InProgress) &&
    ((availableUntil && now > availableUntil) || now > expiredAt)
  ) {
    return STATUS.OVERDUE;
  } else if (status === SessionStatus.NotStarted) {
    return STATUS.NOT_STARTED;
  } else if (status === SessionStatus.InProgress) {
    return STATUS.IN_PROGRESS;
  } else {
    return STATUS.COMPLETED;
  }
};
